export default "__VITE_ASSET__CGwU1969__"